import { ArrowRight } from "lucide-react";
import { RevealHeading } from "@/components/RevealHeading";
import { useCalendly } from "@/components/CalendlyContext";

export function FinalCTA() {
  const { openCalendly } = useCalendly();

  return (
    <section
      data-testid="final-cta-section"
      className="relative py-36 md:py-48 border-t border-white/10 bg-[#0A0A0A] overflow-hidden"
    >
      <div className="absolute -left-40 top-1/2 -translate-y-1/2 w-[500px] h-[500px] rounded-full bg-violet-600/10 blur-[120px] pointer-events-none" />
      <div className="container-custom relative z-10 text-center">
        <RevealHeading
          tag="h2"
          lines={["LET'S BUILD", "WHAT'S NEXT."]}
          className="font-display font-black text-5xl sm:text-6xl lg:text-7xl leading-[0.98] tracking-tight text-white"
        />
        <button
          data-testid="final-cta-book-call-btn"
          onClick={openCalendly}
          className="group mt-12 inline-flex items-center gap-3 bg-white text-black font-bold text-xs tracking-widest uppercase px-10 py-5 hover:bg-violet-500 hover:text-white transition-colors duration-300"
        >
          Book A Strategy Call
          <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />
        </button>
      </div>
    </section>
  );
}
